module.exports = __webpack_public_path__ + "static/sectionafter-af97cc27c543e14076e7194bc89f9791.png";